export function fetcher<T>(input: RequestInfo | URL, init?: RequestInit) {
    return fetch(input, init).then((res) => res.json() as T);
}
